import { message } from 'antd';
import { apiErrorMessage } from './apiErrorMessage';
import { getToastCopy } from '../i18n/locale';

const TOAST_TOP = 64;
const TOAST_DURATION = 4;
const TOAST_MAX_COUNT = 3;

/** App 마운트 시 1회 호출 — 중복 토스트·위치 통일 */
export function initAppToast(): void {
  message.config({
    top: TOAST_TOP,
    duration: TOAST_DURATION,
    maxCount: TOAST_MAX_COUNT,
  });
}

export const appToast = {
  success(text: string): void {
    message.success(text);
  },
  error(text: string): void {
    message.error(text);
  },
  info(text: string): void {
    message.info(text);
  },
  errorFromApi(err: unknown, fallback?: string): void {
    const toast = getToastCopy();
    message.error(apiErrorMessage(err, fallback ?? toast.error.generic));
  },
  get copy() {
    return getToastCopy();
  },
};
